export default __webpack_public_path__ + "static/media/HomeSlider2.c14ba622.jpg";